import {
  Card,
  Grid,
  Typography,
  Box,
  CardContent,
  CardMedia,
  Chip,
  Button,
  IconButton,
  Container,
} from "@mui/material";
import React, { useRef, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import k1 from "../assets/k1.png";
import k2 from "../assets/k2.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import StarIcon from "@mui/icons-material/Star";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import EastIcon from "@mui/icons-material/East";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const servicesData = [
  {
    title: "Venues",
    desc: "Banquet Halls, Marriage Garden / Lawn...",
    img: k1,
    bgcolor: "#f7c59f",
  },
  {
    title: "Photographers",
    desc: "Wedding, Event, Candid Photographers",
    img: k2,
    bgcolor: "#d9b0a3",
  },
  {
    title: "Caterers",
    desc: "Delicious and customized catering services",
    img: k2,
    bgcolor: "#c9e4de",
  },
  {
    title: "Decorators",
    desc: "Creative stage and venue decorators",
    img: k1,
    bgcolor: "#fde2e4",
  },
  {
    title: "Makeup Artists",
    desc: "Professional bridal and party makeup",
    img: k1,
    bgcolor: "#e2ece9",
  },
  {
    title: "DJ & Music",
    desc: "DJ, Bands, and live music performances",
    img: k2,
    bgcolor: "#d8dffc",
  },
  {
    title: "Mehendi Artists",
    desc: "Traditional and stylish mehendi designs",
    img: k2,
    bgcolor: "#f1c0e8",
  },
  {
    title: "Invitations",
    desc: "Wedding cards and digital invites",
    img: k1,
    bgcolor: "#b5ead7",
  },
  {
    title: "Transportation",
    desc: "Luxury cars, buses, and logistics",
    img: k1,
    bgcolor: "#ffdac1",
  },
  {
    title: "Event Planners",
    desc: "Complete wedding & event planning",
    img: k2,
    bgcolor: "#e2f0cb",
  },
];

const choreographers = [
  {
    title: "PreWed Memories",
    location: "Hiran Magri, Udaipur",
    price: "$11,000 onwards",
    img: k1,
    rating: 4.5,
    reviews: 128,
  },
  {
    title: "Dance Fever",
    location: "Bangalore",
    price: "$15,000 onwards",
    img: k1,
    rating: 4.8,
    reviews: 95,
  },
  {
    title: "Rhythm Beats",
    location: "Mumbai",
    price: "$12,500 onwards",
    img: k1,
    rating: 4.3,
    reviews: 112,
  },
  {
    title: "Step Up Crew",
    location: "Delhi",
    price: "$18,000 onwards",
    img: k1,
    rating: 4.7,
    reviews: 87,
  },
  {
    title: "Groove Nation",
    location: "Hyderabad",
    price: "$10,000 onwards",
    img: k1,
    rating: 4.2,
    reviews: 76,
  },
  {
    title: "Bollywood Moves",
    location: "Pune",
    price: "$14,000 onwards",
    img: k1,
    rating: 4.6,
    reviews: 103,
  },
  {
    title: "Dance Vibes",
    location: "Chennai",
    price: "$16,000 onwards",
    img: k1,
    rating: 4.4,
    reviews: 91,
  },
];

const makeupArtists = [
  {
    title: "Glamour Bridals",
    location: "Mumbai",
    price: "$8,000 onwards",
    img: k2,
    rating: 4.7,
    reviews: 215,
  },
  {
    title: "Blush & Blossom",
    location: "Delhi",
    price: "$9,500 onwards",
    img: k2,
    rating: 4.9,
    reviews: 187,
  },
  {
    title: "Royal Beauty",
    location: "Udaipur",
    price: "$12,000 onwards",
    img: k2,
    rating: 4.8,
    reviews: 142,
  },
  {
    title: "Bridal Glow",
    location: "Bangalore",
    price: "$7,500 onwards",
    img: k2,
    rating: 4.6,
    reviews: 168,
  },
  {
    title: "Divine Makeovers",
    location: "Hyderabad",
    price: "$8,800 onwards",
    img: k2,
    rating: 4.5,
    reviews: 125,
  },
  {
    title: "Elegance Studio",
    location: "Chennai",
    price: "$10,200 onwards",
    img: k2,
    rating: 4.4,
    reviews: 98,
  },
];

const photographers = [
  {
    title: "Capture Moments",
    location: "Jaipur",
    price: "$15,000 onwards",
    img: k1,
    rating: 4.9,
    reviews: 245,
  },
  {
    title: "Eternal Frames",
    location: "Goa",
    price: "$18,500 onwards",
    img: k1,
    rating: 4.8,
    reviews: 192,
  },
  {
    title: "Dream Wedding Photos",
    location: "Kerala",
    price: "$16,800 onwards",
    img: k1,
    rating: 4.7,
    reviews: 176,
  },
  {
    title: "Candid Memories",
    location: "Udaipur",
    price: "$20,000 onwards",
    img: k1,
    rating: 4.9,
    reviews: 218,
  },
  {
    title: "Shutterbug Studios",
    location: "Mumbai",
    price: "$14,200 onwards",
    img: k1,
    rating: 4.6,
    reviews: 157,
  },
  {
    title: "Perfect Frame",
    location: "Delhi",
    price: "$17,500 onwards",
    img: k1,
    rating: 4.7,
    reviews: 184,
  },
];

const Services = () => {
  const [favorites, setFavorites] = useState({});
  const sliderRef = useRef(null);

  const toggleFavorite = (id) => {
    setFavorites(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // Custom arrow components
  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <Box
        className={className}
        style={{
          ...style,
          display: "block",
          right: "-25px",
          zIndex: 1,
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: "#6d1675",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            "&:hover": {
              backgroundColor: "#8a1c94",
            },
          }}
        >
          <ArrowForwardIosIcon sx={{ color: "white", fontSize: 18 }} />
        </Box>
      </Box>
    );
  };

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <Box
        className={className}
        style={{
          ...style,
          display: "block",
          left: "-25px",
          zIndex: 1,
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: "#6d1675",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            "&:hover": {
              backgroundColor: "#8a1c94",
            },
          }}
        >
          <ArrowBackIosIcon sx={{ color: "white", fontSize: 18 }} />
        </Box>
      </Box>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    cssEase: "linear",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const SectionHeading = ({ title, highlight }) => (
    <Box sx={{ mb: 4, textAlign: "center", position: "relative" }}>
      <Typography
        sx={{
          fontSize: { xs: 26, md: 32 },
          fontWeight: "bold",
          mb: 1,
          color: "#6d1675"
        }}
      >
        {title}{" "}
        <span style={{ color: "#ffc20f" }}>{highlight}</span>
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          maxWidth: 300,
          mx: "auto",
        }}
      >
        <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
        <Box
          sx={{
            px: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
        </Box>
        <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
      </Box>
    </Box>
  );

  const ServiceCard = ({ service }) => (
    <Card
      sx={{
        display: "flex",
        borderRadius: 3,
        overflow: "hidden",
        bgcolor: service.bgcolor,
        transition: "transform 0.3s, box-shadow 0.3s",
        height: "100%",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: 6,
        },
      }}
    >
      <Box
        sx={{
          flex: 8,
          p: { xs: 2, md: 4 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#6d1675",  }}>
          {service.title}
        </Typography>
        <Box sx={{ height: 3, bgcolor: "#6d1675", mb: 2, borderRadius: 4, width: '60px' }} />
        <Typography variant="body2" sx={{ color: "#5a5a5a", mb: 2 }}>
          {service.desc}
        </Typography>
        <Button
          endIcon={<EastIcon />}
          sx={{
            color: "#6d1675",
            fontWeight: "bold",
            alignSelf: "flex-start",
            "&:hover": { bgcolor: "transparent" },
          }}
        >
          Explore
        </Button>
      </Box>

      <Box
        sx={{
          flex: 5,
          position: "relative",
          overflow: "hidden",
          borderTopLeftRadius: "50% 50%",
          borderBottomLeftRadius: "50% 50%",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "linear-gradient(to left, rgba(0,0,0,0.1), transparent)",
            zIndex: 1,
          },
        }}
      >
        <Box
          component="img"
          src={service.img}
          alt={service.title}
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
    </Card>
  );

  const VendorCard = ({ vendor, index }) => (
    <Card
      sx={{
        width: 300,
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 8px 16px rgba(109, 22, 117, 0.1)",
        mx: "auto",
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: "0 12px 20px rgba(109, 22, 117, 0.2)",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          image={vendor.img}
          alt={vendor.title}
          sx={{
            height: 220,
            objectFit: "cover",
            width: "100%",
          }}
        />

        <IconButton
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            bgcolor: "white",
            color: favorites[`vendor-${index}`] ? "#ff4081" : "#ccc",
            "&:hover": { bgcolor: "rgba(255,255,255,0.9)" },
          }}
          onClick={() => toggleFavorite(`vendor-${index}`)}
        >
          {favorites[`vendor-${index}`] ? <FavoriteIcon /> : <FavoriteBorderIcon />}
        </IconButton>

        <Chip
          icon={<StarIcon color="#ffc20f" sx={{ color: "gold", fontSize: 16 }} />}
          label={`${vendor.rating} (${vendor.reviews})`}
          sx={{
            position: "absolute",
            bottom: 12,
            left: 12,
            bgcolor: "rgba(76, 175, 80, 0.9)",
            color: "white",
            fontWeight: "bold",
          }}
        />
      </Box>

      <CardContent sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#6d1675", mb: 0.5 }}>
          {vendor.title}
        </Typography>
        <Typography sx={{ color: "#909090", fontSize: 14, mb: 1 }}>
          {vendor.location}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontWeight: "bold", fontSize: 18, color: "#e91e63" }}>
            {vendor.price}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            sx={{
              borderRadius: 2,
              color: "#6d1675",
              borderColor: "#6d1675",
              "&:hover": { borderColor: "#6d1675", bgcolor: "rgba(109, 22, 117, 0.04)" }
            }}
          >
            View Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <>
      <Header />
      <Box sx={{ mt: 14, px: { xs: 2, md: 4 } }}>

        {/* Wedding Categories Section */}
        <SectionHeading title="Wedding" highlight="Categories" />

        <Grid container spacing={3} sx={{ mb: 8 }}>
          {servicesData.map((service, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }} key={index}>
              <ServiceCard service={service} />
            </Grid>
          ))}
        </Grid>

        {/* Trending Choreographers Section */}
        <Box sx={{ mb: 8, position: "relative",mx:4  }}>
          <SectionHeading title="Trending" highlight="Choreographers" />

          <Box sx={{ position: "relative" }}>
            <Slider ref={sliderRef} {...settings}>
              {choreographers.map((choreo, index) => (
                <Box key={index} sx={{ px: 1, py: 2 }}>
                  <VendorCard vendor={choreo} index={index} />
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>

        {/* Wedding Makeup Artists Section */}
        <Box sx={{ mb: 8, position: "relative", mx:4 }}>
          <SectionHeading title="Wedding" highlight="Makeup Artists" />

          <Box sx={{ position: "relative" }}>
            <Slider {...settings}>
              {makeupArtists.map((artist, index) => (
                <Box key={index} sx={{ px: 1, py: 2 }}>
                  <VendorCard vendor={artist} index={index + 10} />
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>

        {/* Top Pre Wedding Photographers Section */}
        <Box sx={{ mb: 8, position: "relative",mx:4 }}>
          <SectionHeading title="Top Pre Wedding" highlight="Photographers" />

          <Box sx={{ position: "relative" }}>
            <Slider {...settings}>
              {photographers.map((photographer, index) => (
                <Box key={index} sx={{ px: 1, py: 2 }}>
                  <VendorCard vendor={photographer} index={index + 20} />
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>
      </Box>

      <Footer />
    </>
  );
};

export default Services;